// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"176":"styles","708":"component---src-pages-404-js","936":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"176":"c07d6bf974996a2c8ae0","492":"488c0a35edee256259ce","708":"9554cd0382a72cd0c703","936":"ee1b031c4581020f5cd9","972":"6ca31ffd4d254ebacb50"}[chunkId] + ".js";
};